import $ from "jquery";

export const backButton = function () {
	if (!($(".js-back-button").length > 0)) return false;

	const previousUrl = $(".js-previous-url").data("url");
	if (previousUrl) {
		$(".js-back-button").attr("onclick", `window.location.href = "${previousUrl}"`);
	}

	document.addEventListener("scroll", stickyBack);

	function stickyBack() {
		var windowTop = $(window).scrollTop();

		if (windowTop > $(".js-back-button").outerHeight()) {
			$('.js-back-button').addClass("is-sticky");
		} else {
			$('.js-back-button').removeClass("is-sticky");
		}
	}
	

};
